import { createStore, applyMiddleware } from 'redux'
import reduces from './reducers'
import { composeWithDevTools } from 'redux-devtools-extension'
import PagesMiddleware from './mniddlewares/pages.middleware'
import MagazinesMiddleware from './mniddlewares/magazines.middleware'
import ElementsMiddleware from './mniddlewares/elements.middleware'
import UiMiddleware from './mniddlewares/ui.middleware'
import { asyncMiddleware } from './mniddlewares/async.middleware'

const middlewares = [
  asyncMiddleware,
  ...MagazinesMiddleware,
  ...PagesMiddleware,
  ...ElementsMiddleware,
  ...UiMiddleware
]
const enhance = composeWithDevTools( 
  applyMiddleware(
    ...middlewares
  ) 
)
const store = createStore( reduces,  enhance )

if( module.hot ) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept( './reducers', () => {
    store.replaceReducer( require( './reducers' ).default )
  } )
}

export default store


// WEBPACK FOOTER //
// ./src/store/index.js